const API = process.env.REACT_APP_BACKEND_URL;

export const Pic = ({ base, alt, className, m, sizes }) => (m ? (
  <picture>
    <source media="(min-width: 900px)" srcSet={`${API}${m.desktop}`} />
    <img src={`${API}${m.mobile}`} alt={alt} loading="lazy" decoding="async" width="400" height="267" className={className} />
  </picture>
) : (
  <picture>
    <source type="image/avif" srcSet={sizes ? `${base}-400.avif 400w, ${base}-828.avif 828w` : `${base}-400.avif`} sizes={sizes} />
    <img src={`${base}-640.webp`} alt={alt} loading="lazy" decoding="async" fetchPriority="low" width="400" height="267" className={className} />
  </picture>
));

export const useSiteMedia = (setMedia) => () => {
  const get = () => fetch(`${API}/api/public/site-media`).then((r) => (r.ok ? r.json() : {})).then(setMedia).catch(() => {});
  if (document.readyState === "complete") get(); else window.addEventListener("load", get, { once: true });
  return () => window.removeEventListener("load", get);
};
